import { IDataColumnDefProps, ITextQuery, TextQuery } from "@plex/react-components";

import { applyPickerFilter } from "ui/shared/helpers/plex-components";

import { IPickerSearchCriterion } from "./Picker.types";

export const createPickerSearchCriterion = <T>(query: ITextQuery = TextQuery.simple(""), columns: Array<IDataColumnDefProps<T>> = []): IPickerSearchCriterion<T> => {
  return {
    query: query,
    searchedColumns: columns
  };
};

export const filterPickerData = <T>(rows: T[], criterion: IPickerSearchCriterion<T> = createPickerSearchCriterion()) => {
  return applyPickerFilter(rows, criterion, criterion.defaultValueProvider || (() => ""));
};
